export default __webpack_public_path__ + "static/media/basic-bear.00d21205.svg";